import { ApiPromise } from '@/types';
import { HTTP } from '@/utils';

export default class LocationTypesService {
  static resource = 'location-types';

  static getLocationTypes(): ApiPromise {
    return HTTP.get(this.resource);
  }
}
